import { MemoElement, MemosActions } from '../../slices/memoSlice'
import { Memo, MemoContent } from '../../../types/Memo'
import {
  addDoc,
  collection,
  doc,
  DocumentData,
  DocumentReference,
  DocumentSnapshot,
  updateDoc,
} from 'firebase/firestore'
import { dbService } from '../../../utils/fbase'
import { getMemoCollectionId } from '../../../utils/dbUtils'
import { call, put, select } from 'redux-saga/effects'
import { RootState } from '../../rootState'
import { ReactElement } from 'react'
import { ToastActions } from '../../slices/toastSlice'
import { makeShort } from '../../../utils/stringUtils'
import { LocationActions } from '../../slices/locationSlice'
import { User } from '../../../types/User'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* handleFinalMemoSaga() {
  const memos: ReactElement[] = yield select(
    (state: RootState) => state.memo.memos
  )

  const finalMemos: MemoElement[] = yield select(
    (state: RootState) => state.memo.finalMemos
  )

  if (memos.length === finalMemos.length) {
    const newList: MemoElement[] = []
    //위치 잡기 (정렬)
    for (let i = 0; i < finalMemos.length; i++) {
      const b = finalMemos[i]
      const index = memos.findIndex((e) => e.key === b.id)
      if (index === -1) {
        continue
      }
      newList.push({ ...b, index: index })
    }
    newList.sort((a, b) => {
      const aIdx = a.index || 0
      const bIdx = b.index || 0
      if (aIdx > bIdx) {
        return 1
      } else if (aIdx < bIdx) {
        return -1
      } else {
        return 0
      }
    })

    const title: string = yield select((state: RootState) => state.memo.title)
    const link: string = yield select((state: RootState) => state.memo.link)
    const heads: string = yield select((state: RootState) => state.memo.heads)
    const user: User = yield select((state: RootState) => state.memo.user)
    const memoId: string = yield select((state: RootState) => state.memo.memoId)

    const a: MemoContent[] = []

    newList.forEach((e) =>
      a.push({ index: e.index || 0, korean: e.korean, other: e.other })
    )

    //update
    if (memoId) {
      const memo: Memo = {
        title: title,
        link: link,
        contents: a,
        updatedAt: new Date().getTime(),
        userId: user.id,
        author: {
          displayName: user.name,
          thumb: user.photoUrl,
        },
        heads,
      }
      try {
        const docRef = doc(dbService, getMemoCollectionId(), memoId)
        yield call(update, docRef, memo)

        yield put(
          ToastActions.set({
            text: `${makeShort(memo.title, 10)} successfully updated.`,
          })
        )
        yield put(LocationActions.set({ path: `/memo/${memoId}` }))
      } catch (e) {
        //
      } finally {
        yield put(MemosActions.clearFinalMemo())
        yield put(MemosActions.resetUpdateData())
      }
    } else {
      //insert
      const memo: Memo = {
        title: title,
        link: link,
        contents: a,
        timestamp: new Date().getTime(),
        updatedAt: new Date().getTime(),
        userId: user.id,
        author: {
          displayName: user.name,
          thumb: user.photoUrl,
        },
        heads,
      }
      try {
        const data: DocumentSnapshot<DocumentData> = yield call(
          addDoc,
          collection(dbService, getMemoCollectionId()),
          memo
        )

        yield put(
          ToastActions.set({
            text: `${makeShort(memo.title, 10)} successfully added.`,
          })
        )
        yield put(LocationActions.set({ path: `/memo/${data.id}` }))
      } catch (e) {
        //
      } finally {
        yield put(MemosActions.clearFinalMemo())
      }
    }
  }
}

function update(docRef: DocumentReference<DocumentData>, memo: Memo) {
  return updateDoc(docRef, { ...memo })
    .then(() => {
      //
    })
    .catch(() => {
      //
    })
}
